import LongLat from "@mapmycustomers/shared/types/base/LongLat";

const decodePolyline = (encoded: string): LongLat[] =>
  google.maps.geometry.encoding
    .decodePath(encoded)
    .map((latLng): LongLat => [latLng.lng(), latLng.lat()]);

export default decodePolyline;
